import React, { useEffect, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
import {
    GetASD,
    GetASDPostventas,
    GroupByForeignKey,
    GroupByPropCheck,
    GroupByProps,
} from "../../Finanzas/Actions/GetContainer";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { EjercicioByRange } from "../../Finanzas/Helper/EjercicioByRange";
import { PeriodoSelect } from "../../Ventas/FacturacionMaquinaria/PeriodoSelect";
import { MostrarSelect } from "./MostrarSelect";
import { InteresSelect } from "./InteresSelect";
import { MotivosSelect } from "./MotivosSelect";

const FiltroMensajeriaPostventa = ({
    onExecute,
    boxState,
    onBoxChange,
    cargarfiltros = true,
    mostrarinteres = false,
    mostrarmotivo = false,
    handlePrimerMostrar
}) => {
    const [openModal, setOpenModal] = useState(false);
    const [state, setState] = useState({
        linea: 0,
        adr: [],
        sucursal: [],
        interes: "CC",
        motivo: "CC",
        mostrar: "C",
        ejercicio_inicio: new Date().getFullYear(),
        ejercicio_fin: new Date().getFullYear(),
        periodo: new Date().getMonth() + 1,
        periodo_inicio: new Date().getMonth() + 1,
        periodo_fin: new Date().getMonth() + 1,
    });
    const { data, adr, sucursal, departamento } = state;
    const onOpenModal = () => {
        const container = document.getElementById("mdlFiltros-modal");
        if (!container) return;
        if (openModal) {
            container.style.display = "flex";
            setOpenModal(false);
        } else {
            container.style.display = "none";
            setOpenModal(true);
        }
    };

    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    useEffect(() => {
        // onClose();
        if (cargarfiltros)
            GetASDPostventas()
                .then((res) => {
                    setState(prev => ({
                        ...prev,
                        data: res
                    }));
                    onBoxChange("pv", {
                        adr: GroupByProps(res, ["idadr", "adr"]),
                        sucursal: [],
                        departamento: [],
                    });
                })
                .catch((err) => console.log(err));
    }, [state.mostrar]);

    useEffect(() => {
        if (!data) return;

        // Obtener ADR únicos según el estado de mostrar
        const uniqueADRs = GroupByProps(
            data.filter(item => item.mensajeria === state.mostrar),
            ["idadr", "adr"]
        ).map(item => ({ ...item, checked: true }));

        // Mantener selección previa de ADR
        const newadr = uniqueADRs.map(item => {
            const selected = adr?.find(a => a.idadr === item.idadr);
            return { ...item, checked: selected ? selected.checked : true };
        });

        // Filtrar sucursales asociadas a ADR seleccionados
        const selectedADRs = newadr.filter(a => a.checked).map(a => a.idadr);

        let filteredSucursal;
        if (selectedADRs.length > 0) {
            filteredSucursal = data
                .filter(item => selectedADRs.includes(item.idadr) && item.mensajeria === state.mostrar)
                .map(item => ({ ...item, checked: false }));
        } else {
            // Si no hay ADR seleccionado, no mostrar sucursales o mostrar todas según tu lógica
            filteredSucursal = [];
        }

        const newsucursal = GroupByPropCheck(filteredSucursal, ["idsucursal", "sucursal"], false);
        const newdepartamento = GroupByPropCheck(data, ["iddepartamento", "departamento"], false);

        setState(prev => ({
            ...prev,
            adr: newadr,
            sucursal: newsucursal,
            departamento: newdepartamento,
        }));
    }, [data, state.mostrar]);


    const onCargar = () => {
        if (
            state.ejercicio_inicio === undefined ||
            state.ejercicio_inicio === null ||
            state.ejercicio_inicio === ""
        ) {
            Swal.fire("DASHBOARD", "Favor de seleccionar el ejercicio de inicio", "warning");
            return;
        }
        if (
            state.periodo_inicio === undefined ||
            state.periodo_inicio === null ||
            state.periodo_inicio === ""
        ) {
            Swal.fire(
                "DASHBOARD",
                "Favor de seleccionar el periodo de inicio",
                "warning"
            );
            return;
        }
        onOpenModal();
        onExecute(
            state.ejercicio_inicio,
            state.ejercicio_fin,
            state.periodo_inicio,
            state.periodo_fin,
            state.mostrar,
            state.interes,
            state.motivo
        );
        // .then((result) => {
        // })
        // .catch((error) => {
        //     Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
        // });
    };

    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };

    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr":
                const newAdrArray = [...adr];
                newAdrArray[index].checked = target.checked;

                // Solo los ADR activos
                const activeADRs = newAdrArray.filter(a => a.checked);
                const activeADRIds = activeADRs.map(a => a.idadr);

                let filteredSucursales = [];

                if (activeADRIds.length > 0) {
                    // Si hay ADR seleccionados, filtrar sucursales por ADR y mostrar
                    filteredSucursales = data
                        .filter(
                            item =>
                                activeADRIds.includes(item.idadr) &&
                                item.mensajeria === state.mostrar
                        )
                        .map(item => ({ ...item, checked: false }));
                } else {
                    // Si no hay ADR seleccionado, mostrar todas las sucursales a las que tiene acceso según mostrar
                    filteredSucursales = data
                        .filter(item => item.mensajeria === state.mostrar)
                        .map(item => ({ ...item, checked: false }));
                }

                const groupedSucursales = GroupByPropCheck(
                    filteredSucursales,
                    ["idsucursal", "sucursal"],
                    false
                );

                setState({
                    ...state,
                    adr: newAdrArray,
                    sucursal: groupedSucursales,
                    departamento: []
                });

                onBoxChange("pv", {
                    adr: activeADRs.map(a => ({ idadr: a.idadr, adr: a.adr })),
                    sucursal: groupedSucursales,
                    departamento: []
                });
                break;


            case "chk-sucursal":
                var newarray = sucursal;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    departamento: [],
                });
                setState({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    departamento: departamentoactivo,
                });
                setState({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };

    const onChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };

    const onChangeestatus = (e) => {
        const { name, value } = e.target;
        if (name === "estatus") {
            setState((prev) => ({
                ...prev,
                estatus: value,
                motivo: value === "SI" ? prev.motivo : "CC", // solo mantiene motivo si sigue en 'SI'
            }));
        } else {
            setState((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
        onBoxChange(name, value);
    };

    const onPrimerMostrar = (valor) => {
        setState(prev => ({
            ...prev,
            mostrar: valor,
        }));
        if (handlePrimerMostrar)
            handlePrimerMostrar(valor);
    };

    return (
        <div className="filtros-pedidos-facturados">
            <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
                <FilterAltIcon /> Filtrar
            </div>
            <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
                <PlantillaScreen
                    titulo={`Filtro`}
                    className_main={1}
                    className={"modal-filtro-resumen-cartera-mensual"}
                >
                    <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
                        X
                    </div>
                    <div className="modal-filtro-resumen-cartera-mensual-container">
                        <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
                            <div className="filtro-tiempo-tipo">
                                <div className="filtro-group">
                                    <label>Ejercicio Inicio</label>
                                    <EjercicioByRange
                                        name="ejercicio_inicio"
                                        value={state.ejercicio_inicio}
                                        onChange={onChange}
                                        extrayear={3}
                                    />
                                    <label>Ejercicio Fin</label>
                                    <EjercicioByRange
                                        name="ejercicio_fin"
                                        value={state.ejercicio_fin}
                                        onChange={onChange}
                                        extrayear={3}
                                    />
                                    <label>Periodo Inicio</label>
                                    <PeriodoSelect
                                        name="periodo_inicio"
                                        value={state.periodo_inicio}
                                        onChange={onChange}
                                    />
                                    <label>Periodo Fin</label>
                                    <PeriodoSelect
                                        name="periodo_fin"
                                        value={state.periodo_fin}
                                        onChange={onChange}
                                    />
                                    <label>Mostrar</label>
                                    <MostrarSelect
                                        name="mostrar"
                                        value={state.mostrar}
                                        onChange={onChange}
                                        onPrimerMostrar={onPrimerMostrar}
                                    />
                                    {mostrarinteres && (
                                        <>
                                            <label>Interes</label>
                                            <InteresSelect
                                                name="interes"
                                                value={state.interes}
                                                onChange={onChangeestatus}
                                            />
                                        </>
                                    )}
                                    {state.interes === "SI" && (state.mostrar === "C" || state.mostrar === "S") && mostrarmotivo && (
                                        <>
                                            <label>Motivo</label>
                                            <MotivosSelect
                                                name="motivo"
                                                value={state.motivo}
                                                onChange={onChange}
                                                tipo={state.mostrar}
                                            />
                                        </>
                                    )}
                                </div>
                                <div
                                    className="mdlFiltros-modal-acciones-guardar"
                                    onClick={onCargar}
                                >
                                    Cargar
                                </div>
                            </div>
                            <div className="filtro-adr">
                                <div className="title title-adr">REGION</div>
                                {adr.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-adr"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idadr}
                                        />
                                        <label>{item.adr}</label>
                                    </div>
                                ))}
                            </div>
                            <div className="filtro-sucursal">
                                <div className="title-sucursal">SUCURSAL</div>
                                {sucursal.map((item, index) => (
                                    <div key={`${item}-${index}`} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-sucursal"
                                            className="my-checkbox"
                                            onChange={(e) => selectedClick(e, index)}
                                            checked={item.checked}
                                            value={item.idsucursal}
                                        />
                                        <label onClick={labelclick}>
                                            {capitalizeWords(item.sucursal)}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="mdlFiltros-modal-acciones"></div>
                    </div>
                </PlantillaScreen>
            </div>
        </div>
    );
};

export default FiltroMensajeriaPostventa;
